import styled from "@emotion/styled";
import { AnimatePresence, CustomValueType, motion } from "framer-motion";
import React from "react";

export default function DismissableViewOverlay(props: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  initialY?: string | number | CustomValueType | undefined;
}) {
  return (
    <AnimatePresence>
      {props.isOpen && (
        <Root
          initial={{ translateY: props.initialY ?? "20%", opacity: 0 }}
          animate={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          exit={{ translateY: props.initialY ?? "20%", opacity: 0 }}
        >
          {props.children}
        </Root>
      )}
    </AnimatePresence>
  );
}

const Root = styled(motion.div)`
  --footer-height: 76px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 100%;

  .Scaffold {
    padding-bottom: var(--footer-height);
    height: calc(100% - var(--footer-height));
  }
`;
